<div class="card-wrapper">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3">
        <div class="card shadow-2">
          <!-- Question Loading Container -->
          <div class="question-wrapper" id="QuestionWrapper">
            <div id="skipFirstSection">
              <div class="form-with-lbl radio1" id="divOtherHealthInsurance" *ngIf="getFilteredQuestion('Q1'); let question">
                <h3>{{ question.QuestionText }}</h3>
                <div *ngFor="let yesNo of question.Options; let i = index" class="form-control normal-radio" id="div_OtherHealthInsurance_{{ i }}" title="{{ yesNo.Text }}">
                  <label>
                    <p>{{ yesNo.Text }}</p>
                    <input
                      type="radio"
                      name="radio_OtherHealthInsurance"
                      (click)="selectOtherHealthInsurance(yesNo.Value)"
                      id="radio_{{ yesNo.RiskValue }}"
                      title="{{ yesNo.Text }}"
                      [checked]="isOtherHealthInsurance(yesNo.Value)" />
                    <span class="radiomark"><span></span></span>
                  </label>
                </div>
              </div>
              <div class="datepicker-area single">
                <div class="row">
                  <div class="col-xs-12 col-sm-12" id="divPolicyStartReadDate" *ngIf="getFilteredQuestion('Q2'); let question">
                    <h3>{{ question.QuestionText }}</h3>
                    <app-policy-calander [contractType]="contractType" (doCheck)="submitPolicyStartDate($event)"></app-policy-calander>
                    <p
                      id="errorTxtCalendarPolicyDate"
                      class="error"
                      [class.hidden]="!validationUiService.isInsuredSubmit || (validationUiService.isInsuredSubmit && validationUiService.isPolicyStartRealDate(contractType))">
                      {{ question.ErrorText }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="form-with-lbl small-textbox">
                <!--<h3 _tmplitem="1"  class="">Personas a incluir en el seguro</h3>-->
                <div class="row">
                  <div class="col-xs-12 col-md-6" id="divInsurer1" *ngIf="getFilteredQuestion('Q3'); let question">
                    <h3 class="">{{ question.Title }}</h3>
                    <app-primary-insured-dob [contractType]="contractType" (submitAnswer)="submitPrimaryDOB($event)"></app-primary-insured-dob>
                    <p
                      id="error-date1"
                      class="error"
                      [class.hidden]="!validationUiService.isInsuredSubmit || (validationUiService.isInsuredSubmit && validationUiService.isPrimaryInsuredDob(contractType))">
                      {{ question.ErrorText }}
                    </p>
                    <div class="cj-tooltip-info hidden" style="display: flex" id="dobWarning">
                      <span class="icon icon-alert"></span>
                      <p class="text-9-d-demibold text-09-m-demibold">¡Recuerda!<br class="hidden-xs" />El titular debe ser mayor de edad</p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6" *ngIf="getFilteredQuestion('Q4'); let question">
                    <div class="form-with-lbl two-element">
                      <h3 class="">{{ question.Title }}</h3>
                      <div class="radio-container" id="divPolicyHolderGender">
                        <div
                          class="form-control normal-radio-icon"
                          *ngFor="let genderOptions of question.Options; let i = index"
                          id="divOption_{{ genderOptions.RiskValue }}"
                          title="{{ genderOptions.Text }}">
                          <label
                            class="normal-radio-container"
                            id="lbl_{{ genderOptions.RiskValue }}"
                            [class.error]="validationUiService.isInsuredSubmit && !validationUiService.isPrimaryInsuredGender(contractType)">
                            <input
                              type="radio"
                              [checked]="isGenderSelected(genderOptions.Value)"
                              (click)="selectGender(genderOptions.Value)"
                              id="input_{{ genderOptions.RiskValue }}"
                              title="{{ genderOptions.Text }}" />
                            <div class="radiomark-container shadow-5">
                              <div class="oval">
                                <img id="image_{{ genderOptions.RiskValue }}" src="{{ baseImageUrl }}{{ genderOptions.ImageUrl }}" />
                              </div>
                              <p class="item">{{ genderOptions.Text }}</p>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                    <p
                      id="errorDivPolicyHolderGender"
                      class="error"
                      [class.hidden]="!validationUiService.isInsuredSubmit || (validationUiService.isInsuredSubmit && validationUiService.isPrimaryInsuredGender(contractType))">
                      {{ question.ErrorText }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="form-with-lbl add-data small-textbox">
                <div class="row row-counter" id="dynamicControlContainer">
                  <app-additional-insured-dob [contractType]="contractType" (submitAnswer)="submitAdditionalDOB($event)"></app-additional-insured-dob>
                </div>
              </div>
              <div class="control-add">
                <span class="count-minus" id="count-minus" (click)="removeInsurer()">-</span>
                <span class="count-plus" id="count-plus" (click)="addInsurer()">+</span>
                <p class="control-txt">Añade o elimina personas a asegurar</p>
              </div>
            </div>
            <p id="errorContainer" class="error"></p>
          </div>

          <!-- Questions Submit Buttons (Next & Previous) -->
          <div id="options-wrapper" class="options-wrapper">
            <a href="javascript:void(0)" id="prev" class="btn rounded prev" style="visibility: hidden">
              <i class="icon icon-chevron-left"></i>
            </a>
            <a href="javascript:void(0)" id="next" class="btn solid-main next text-08-d-regular" style="" (click)="moveNext()">Avanzar</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
